import * as types from '@/store/types'
export default {
    bots: state => {
        return state.bots
    },
    loadedBots: state => {
        return state.loadedBots
    },
    getBotById: state => id => {
        return state.bots.find(bot => bot.id === +id)
    },
    getBotByIndex: state => index => {
        return state.bots.length - 1 >= index ? state.bots[index] : null
    },
    getBotIndexById: state => id => {
        return state.bots.findIndex(bot => bot.id === +id)
    },
    modelDefault: state => {
        return state.modelDefault
    },
    moderators: state => {
        return state.moderators
    },
    modelModeratorDef: state => {
        return state.modelModeratorDef
    },
    getModeratorById: state => id => {
        return state.moderators.findIndex(moderator => moderator.user_id === id)
    },
    tariffs: state => {
        return state.tariffs
    },
    getTariffById: state => id => {
        return state.tariffs.find(tariff => tariff.id === +id)
    }
}
